import design from './design'
import home from './home'
import statistics from './statistics'
import materialSelect from './materialSelect'
const designManager = [
  {
    path: '/design-manager',
    name: 'design-manager',
    component: () => import('@/views/wxapp/designer-manager'),
    redirect: '/design-manager/home',
    meta: {
      title: '设计'
    },
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/wxapp/designer-manager/home/home'),
        redirect: '/design-manager/home/homePage',
        meta: {
          title: '设计师工作台'
        },
        children: [
          {
            path: 'homePage',
            name: 'homePage',
            component: () => import('@/views/wxapp/designer-manager/home/index'),
            meta: {
              title: '设计师工作台'
            }
          },
          {
            path: 'informationList',
            name: 'informationList',
            component: () => import('@/views/wxapp/designer-manager/home/informationList/index'),
            meta: {
              title: '消息提醒'
            }
          },
          {
            path: 'customer',
            name: 'customer',
            component: () => import('@/views/wxapp/designer-manager/statistics/index'),
            meta: {
              title: '设计师工作台'
            }
          },
          {
            path: 'customer-list',
            name: 'designManagerCustomerList',
            component: () => import('@/views/wxapp/service-system/list'),
            meta: {
              title: '我的用户'
            }
          }
        ]
      },
      ...design,
      ...home,
      ...statistics,
      ...materialSelect
    ]
  }
]
export default designManager
